export default __webpack_public_path__ + "static/media/GW.53cb2b47.svg";